module.exports = __webpack_public_path__ + "img/资产负债表.4b62cb02.png";